<script setup>
import {getCurrentInstance, onMounted, ref} from "vue";
const rootElem = ref();
const { root } = getCurrentInstance();
onMounted(() => {
    rootElem.value.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', e => {
            root.setupState.toggleMobileNav(false);
        })
    })
})
</script>

<template>
    <nav ref="rootElem">
        <slot/>
    </nav>
</template>
